import React, { Component, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Styles from "./styles.module.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import H1 from '../../components/typography/h1';
import H2 from "../../components/typography/h2";
import homeimg1 from '../../assets/img/homeimg1.png';
import homeimg2 from '../../assets/img/homeimg2.png';
import playicon from '../../assets/img/play_button.png'
import search from '../../assets/img/search.png'
import build from '../../assets/img/build.png'
import uiux from '../../assets/img/uiux.png'
import quote1 from '../../assets/img/1.png'
import quote2 from '../../assets/img/2.png'
import delivery from '../../assets/img/delivery.png'
import uiuximg1 from '../../assets/img/ui-ux img1.png'
import uiuximg2 from '../../assets/img/ui-ux img2.png'
import uiuximg3 from '../../assets/img/ui-ux img3.png'
import componentimg from '../../assets/img/Component.png'
import Bannerimg1 from '../../assets/newhomepageimg/conference-room-2.svg'
import Bannerimg2 from '../../assets/newhomepageimg/bannerimg2.svg'
import Serviceimg1 from '../../assets/newhomepageimg/serviceimg1.svg'
import Serviceimg2 from '../../assets/newhomepageimg/serviceimg2.svg'
import Serviceimg3 from '../../assets/newhomepageimg/serviceimg3.svg'
import Serviceimg4 from '../../assets/newhomepageimg/serviceimg4.svg'
import Logo1 from "../../assets/newhomepageimg/logo1.webp"
import Logo2 from "../../assets/newhomepageimg/logo2.webp"
import Logo3 from "../../assets/newhomepageimg/logo3.webp"
import Logo4 from "../../assets/newhomepageimg/logo4.webp"
import Logo5 from "../../assets/newhomepageimg/logo5.webp"
import Logo6 from "../../assets/newhomepageimg/logo6.webp"
import Logo7 from "../../assets/newhomepageimg/logo7.webp"
import Logo8 from "../../assets/newhomepageimg/logo8.webp"
import H3 from "../../components/typography/h3";
import Digital from "./digitalbrands/index"
import Projects from "./projects/index";
import Reviews from "./reviews/index";

import FaqSection from "./faq/index";
import Services from "./services";
function Home() {

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

interface ArrowProps {
  onClick?: () => void;
}

const PrevArrow: React.FC<ArrowProps> = ({ onClick }) => (
  <div className={`${Styles.arrow} ${Styles.prev}`} onClick={onClick}>
<svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.621485 8.10248L8.80273 1.04701C9.10781 0.784903 9.55469 1.02123 9.55469 1.44447V15.5554C9.55469 15.9787 9.10781 16.215 8.80273 15.9529L0.621485 8.8974C0.387305 8.69545 0.387305 8.30443 0.621485 8.10248Z" fill="#FF2E84"/>
</svg>

  </div>
);

const NextArrow: React.FC<ArrowProps> = ({ onClick }) => (
  <div className={`${Styles.arrow1} ${Styles.next}`} onClick={onClick}>
   <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.3785 11.1024L7.19727 4.04689C6.89219 3.78478 6.44531 4.02111 6.44531 4.44435V18.5553C6.44531 18.9785 6.89219 19.2149 7.19727 18.9528L15.3785 11.8973C15.6127 11.6953 15.6127 11.3043 15.3785 11.1024Z" fill="white"/>
</svg>

  </div>
);
 const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true, // fixed typo
  centerPadding: "0px", // adjust space between cards
nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1024, settings: { slidesToShow: 2 }
    },
    {
      breakpoint: 768, settings: { slidesToShow: 1 }
    }
  ]
};
  
  // const settings = {
  //   loop: true,
  //   center: true,
  //   margin: 0,
  //   autoplay: true,
  //   dots: false,
  //   autoplayTimeout: 8500,
  //   smartSpeed: 450,
  //   nav: false,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   adaptiveHeight: true
  // };
 const brands = [
    { name: 'M.A.S.S', logo: Logo1 },
    { name: 'Softsie', logo: Logo2 },
    { name: 'Genie', logo: Logo3 },
    { name: 'Scenta Book', logo: Logo4 },
    { name: 'Best Capital', logo: Logo5 },
     { name: 'Best Capital', logo: Logo6},
      { name: 'Best Capital', logo: Logo7 },
       { name: 'Best Capital', logo: Logo8 }

  ];
  return (
    <section>
      <div className="container">
        <H2>
       <span> Helping businesses grow through innovative digital solutions and strategic marketing that drive lasting success.</span>

          <span></span>
        </H2>
        <div className={Styles.bannertext}>
          
             <div className={Styles.bannertext_1}>
              Our comprehensive web development process covers everything from initial concept and design to final testing and launch, ensuring a seamless and.
            </div>
             <Link to={"/talk_us"} className="btn btn-small" >Lets talk</Link>
        </div></div>
        <div className="container">
          <div className={Styles.bannerimg}>
<img src={Bannerimg1} alt="Banner img1" />
<img src={Bannerimg2} alt="Banner img2" />
          </div>
        </div>
               <div className={Styles.digitalbg}>
  <div className="container">
        <Services  />
        </div>
        </div>
        <div className="container">
 <div className={Styles.marqueeContainer}>
      <div className={Styles.marqueeTrack}>
        {/* First set of brands */}
   {/* {brands.map((brand, index) => (
  <div key={`brand-1-${index}`} className={Styles.brandItem}>
    <img src={brand.logo} alt={brand.name} className={Styles.brandLogo} />
  </div>
))} */}
{brands.map((brand, index) => (
  <div key={`brand-2-${index}`} className={Styles.brandItem}>
    <img src={brand.logo} alt={brand.name} className={Styles.brandLogo} />
  </div>
))}
      </div>
    </div></div>
   <div className={Styles.digitalbgclr}>
  <div className="container" style={{marginTop:"80px",marginBottom:"20px"}}>
      <H3>
      <div className={Styles.Digitaltext}>
          
             <div className={Styles.Digitaltext_1}>
             Digital success through smart
solutions & in-house products.
            </div>
             <Link to={"/talk_us"} className="btn btn-small" >Lets talk</Link>
        </div>

</H3>


<div className={Styles.companydtl}>
        <div className={Styles.companyInfo}>
          <div>
            <h2>50+</h2>
            <p>Satisfied Clients</p>
          </div>
          <div>
            <h2>05+</h2>
            <p>In-House Products</p>
          </div>
          <div>
            <h2>128+</h2>
            <p>Projects</p>
          </div>
        </div>
<div className={Styles.companytext}>
  With a team of passionate experts, we work closely with our clients to understand their goals, craft tailored solutions, and deliver strong results.
</div>
        </div>
        </div></div>

  {/* <div className="container">
          <Digital></Digital>
          </div> */}
          
          <div className="container">
            <Projects/>

            </div>
            <div className={Styles.digitalbg}>
  {/* <div className="container">
          <Reviews></Reviews>
        
          </div> */}
             <div className="container">
        <div className={Styles.testimonial}>
          <div className={Styles.testimonialtext}>
           <div className={Styles.wrapper}>
              
             <H3>
      <h2 className={Styles.headingReview}>
 Join 50+ Satisfied Customers, Real
 Results from Businesses Growing with Us       </h2>
       </H3>
        

          <Slider {...settings} className={Styles.slider_wrap}>
            <div className={Styles.slider}>
              <img className={Styles.img} src={quote1}></img>
              <p className={Styles.testimonialtext_p}>
                Metasoft has done an outstanding job in creating a website that authentically embodies the essence of 
                fragrances and nature. They have excelled in every aspect, from designing the logo to establishing a cohesive brand 
                identity and crafting the website's design and development. Their exceptional work perfectly captures the essence we 
                desired for our fragrance-focused website.</p>
              <img className={Styles.img1} src={quote2}></img>
              <div className={Styles.client}>
              Abraham Samuel
                <span>Managing Partner, Amber Aroma</span>
              </div>
            </div>
            <div className={Styles.slider}>
              <img className={Styles.img} src={quote1}></img>
              <p className={Styles.testimonialtext_p}>
              I am extremely pleased and grateful to the talented website team for creating an exceptional website that perfectly 
              showcases our services. Their ability to transform our vision into reality, with the unique concept of black-and-white 
              images that turn into vibrant colors when the cursor hovers over them, has exceeded our expectations. Their attention 
              to detail and technical expertise has resulted in a visually stunning and engaging website that will undoubtedly leave 
              a lasting impression on our customers. I am confident that this remarkable website will help us attract a wider audience
               and drive our business growth. Thank you for your dedication and exceptional work.
              </p>
              <img className={Styles.img1} src={quote2}></img>
              <div className={Styles.client}>
              Zaheer Marakkar
                <span>Managing Partner, Hostec</span>
              </div>
            </div>
            <div className={Styles.slider}>
              <img className={Styles.img} src={quote1}></img>
              <p className={Styles.testimonialtext_p}>
              I am thrilled to express my utmost satisfaction with the remarkable work accomplished by Metasoft in creating our website. Our primary goal was to develop a platform that effortlessly communicates with our audience, striking a balance between simplicity and elegance. Metasoft has truly exceeded our expectations by not only achieving this objective but also seamlessly integrating the functionality to sell our NFC Business Cards. The result is a captivating and user-friendly website that effectively showcases our products and engages our customers. The team's attention to detail, creative approach, and exceptional craftsmanship have made our vision a reality. We are incredibly grateful for their hard work and dedication, and we look forward to the continued success of our business with this beautiful website as our online storefront.
              </p>
              <img className={Styles.img1} src={quote2}></img>
              <div className={Styles.client}>
              Rajath Ravi
                <span>Founder, ZEEQR

</span>
              </div>
            </div>
          </Slider>
            
          </div>
        </div>
        </div>
      </div>
          </div>
              <div className="container">
                <FaqSection/>
        </div>
      <button className={Styles.scrollTop} onClick={scrollToTop} >Scroll Top</button>
    </section>

  );
}

export default Home;
